'use client';
import { useTableContextValues_unstable } from '../Table/useTableContextValues';
export function useDataGridContextValues_unstable(state) {
    const tableContextValues = useTableContextValues_unstable(state);
    const { tableState, focusMode, selectableRows, subtleSelection, selectionAppearance, resizableColumns, compositeRowTabsterAttribute } = state;
    return {
        ...tableContextValues,
        dataGrid: {
            ...tableState,
            focusMode,
            selectableRows,
            subtleSelection,
            selectionAppearance,
            resizableColumns,
            compositeRowTabsterAttribute
        }
    };
}
